import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import {
  faChevronRight,
  faEye,
  faPen,
  faPlus,
  faTimes,
  faUndo,
} from "@fortawesome/free-solid-svg-icons";
//import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
//import styles from "../../masters/master.css";
import apiUrl from "../apiUrlConstant";
//import CreatableSelect from "react-select/creatable";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";
import * as Yup from "yup";
import { getUserType, fileUploadPath } from "../utils/index";
import { PopupMessage } from "../utils/utils";
import Popup from "reactjs-popup";
//import { Chart } from "react-google-charts";
import {
  Chart as ChartJS,
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line, Bar } from "react-chartjs-2";
import { Chart } from "react-google-charts";
import { counter } from "@fortawesome/fontawesome-svg-core";
ChartJS.register(
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// const reportFilterForm = Yup.object().shape({
//   countryId: Yup.string().required("Required"),
//   stateId: Yup.string().required("Required"),
//   districtId: Yup.string().required("Required"),
//   cityId: Yup.string().required("Required"),
// });
const labels = [
  "Expiring in 3 Months",
  "Expiring in 6 Months",
  "Expiring in 9 Months",
  "Expiring in 12 Months",
  "Expiring in over 12 Months",
];

const Checkbox = ({ id, type, name, handleClick, isChecked, attr }) => {
  return (
    <input
      id={id}
      name={name}
      type={type}
      onChange={handleClick}
      checked={isChecked}
      data-attr={attr}
    />
  );
};

//['January', 'February', 'March', 'April', 'May', 'June', 'July'];
if (getUserType() == "Landlord") {
  var reportFilterForm = Yup.object().shape({
    // assetId: Yup.string().required("Required"),
    //stateId: Yup.string().required("Required"),
    //districtId: Yup.string().required("Required"),
    //cityId: Yup.string().required("Required"),
  });
} else if (getUserType() == "Occupier") {
  var reportFilterForm = Yup.object().shape({
    // brandId: Yup.number().required("Required"),
    // stateId: Yup.string().required("Required"),
    // districtId: Yup.string().required("Required"),
    // cityId: Yup.string().required("Required"),
  });
} else {
  var reportFilterForm = Yup.object().shape({
    // countryId: Yup.string().required("Required"),
    // stateId: Yup.string().required("Required"),
    // districtId: Yup.string().required("Required"),
    // cityId: Yup.string().required("Required"),
  });
}

let monthsArr = [];
var i = 0;
for (; i <= 12; i++) {
  monthsArr.push({ id: i, value: i });
}

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class LeaseExpiryReport extends React.Component {
  groupId = { value: "" };
  state = {
    landloardArr: [],
    assetArr: [],
    subAssetArr: [],
    towerArr: [],
    companyArr: [],
    cityList: [],
    occupierList: [],
    landloardList: [],
    assetsList: [],
    tableTOShow: "RENT",
    companyDetails: {
      'companyPan': ''
    },
    formResponseData: [],
    invoiceList: {},
    initialValues: {
      chargeTypeSelected: "",
      frequencySelected: "",
      chartType: "",
      landloardName: "",
      landloardId: "",
      subAssetName: "",
      subAssetId: "",
      companyName: "",
      companyId: "",
      cityName: "",
      cityId: "",
      occupierName: "",
      occupierId: "",
      companyPan: ""

    }
  };

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/brand/get-all-brands`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          brandList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/get-lease-status`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          leaseStatus: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/get-occupier-landloard`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          landloardList: data.landloardList,
          //occupierList: data.occupierList,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    this.getAssetsList("", "", true);
  }

  componentDidUpdate() { }

  constructor(props) {
    super(props);
    console.log(this.props, "this proopsss");
  }

  getAssetsList = (input, e, cust) => {
    if (
      (typeof e != "undefined" && e.action == "input-change") ||
      cust === true
    ) {
      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        this.state.initialValues.cityId +
        `&assetName=` +
        input,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };


  handleCalenderOnBlur = () => {
    this.state.initialValues.financialYearOne = this.formatDate(
      this.state.financialYearOne
    );
    this.state.initialValues.financialYearTwo = this.formatDate(
      this.state.financialYearTwo
    );
  };


  handleCalculation = (e, index, values) => {
    var total = 0;
    for (const value in values.amount) {
      total += parseInt(values.amount[value]);
    }
    //console.log(total, "total", this.state.formResponseData[index].variance )
    if (typeof index == "undefined") {
      this.setState({ totalInvoiceAmount: total });
    } else {
      var formData = this.state.formResponseData;
      formData[index].variance =
        parseFloat(formData[index].net_charge_amount) - e.target.value;

      this.setState({ totalInvoiceAmount: total, formResponseData: formData }); //, `formResponseData${}` : totalVariance
    }
  };

  valueChangeSubAsset = (newValue, actionMeta) => {
    this.state.initialValues.subAssetId = newValue.value;
    this.state.initialValues.subAssetName = newValue.label;
    this.setState({});
    fetch(`${apiUrl.apiUrl.url}/asset/sub-asset-towers?id=` + newValue.value, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          towerArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  valueFrequencyChange = (newValue, actionMeta) => {
    this.state.initialValues.frequencySelected = newValue.value;
    this.setState({});
  }
  valueChangeChargeType = (newValue, actionMeta) => {
    this.state.initialValues.chargeTypeSelected = newValue.value;
    this.state.initialValues.chargeType = newValue.value;
  }

  valueChangeCompany = (newValue, actionMeta) => {
    this.state.initialValues.companyId = newValue.value;
    this.state.initialValues.companyName = newValue.label;
    this.setState({});
    fetch(`${apiUrl.apiUrl.url}/landlord/get-company?id=` + newValue.value, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data.data, "ata");
        this.setState({
          companyDetails: data.data,
        });
        this.state.initialValues.companyPan = data.data.companyPan;
        this.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  }

  valueChangeAsset = (newValue, actionMeta) => {
    this.state.initialValues.assetId = newValue.value;
    this.state.initialValues.assetName = newValue.label;
    this.setState({});
    //landlord-group/fetch-landlord-list
    fetch(`${apiUrl.apiUrl.url}/asset/asset-sub-assets?id=` + newValue.value, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          subAssetArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleChangeChk = (val) => {
    console.log(val, "clickec");
  }

  handleChangeLandlord = (newValue, actionMeta) => {
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});

    //landlord-group/fetch-landlord-list
    fetch(`${apiUrl.apiUrl.url}/asset/fetch-landlord-all-assets?id=` + newValue.value, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          assetArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });


    fetch(`${apiUrl.apiUrl.url}/landlord/get-group-companies?id=` + newValue.value, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          companyArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChangeClientGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionmeta", actionMeta);
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});
    console.log(newValue, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };

  // handleSelectAll = e => {
  //   setIsCheckAll(!isCheckAll);
  //   setIsCheck(list.map(li => li.id));
  //   if (isCheckAll) {
  //     setIsCheck([]);
  //   }
  // };

  handleClick = (e) => {
    const { id, checked } = e.target;
    console.log("okok", id, checked, e.target.dataset, "str", e, "==");
    var invoiceListObj = this.state.invoiceList;

    if (typeof invoiceListObj[id] == "undefined") {
      invoiceListObj[id] = {};
    }

    if (checked) {
      invoiceListObj[id][e.target.dataset.attr] = checked;
    } else {
      delete invoiceListObj[id][e.target.dataset.attr];
    }

    this.state.invoiceList = invoiceListObj;

    this.setState({});


    // this.setIsCheck([...isCheck, id]);
    // if (!checked) {
    //   this.setIsCheck(isCheck.filter(item => item !== id));
    // }
  };
  redirectAfterSave = () => {
    this.setState({
      messsagePopup: false,
      popupMessageContent: '',
    });
  };

  approveInvoice = () => {
    var self = this;
    if (JSON.stringify(this.state.invoiceList) === JSON.stringify({})) {
      self.setState({
        messsagePopup: true,
        popupContent: 'Please Select Item to proceed.'
      });
      return false;
    }




    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/transaction/process-invoice`,
      data: { 'list': this.state.invoiceList, 'processType': 1, 'period': this.state.initialValues.financialYearOne, 'frequency': this.state.initialValues.frequencySelected },
    }).then(function (response) {
      if (!response.data.success) {
        //actions.setSubmitting(false);
        //actions.setErrors(response.data);
      } else {
        self.setState({
          messsagePopup: true,
          popupContent: 'Data Saved Successfully'
        });
        setTimeout(function () {
          self.state.formResponseData = [];
          self.setState({})
        })
      }
    });
  }


  rejectInvoice = () => {
    var self = this;
    if (JSON.stringify(this.state.invoiceList) === JSON.stringify({})) {
      self.setState({
        messsagePopup: true,
        popupContent: 'Please Select Item to proceed.'
      });
      return false;
    }
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/transaction/process-invoice`,
      data: { 'list': this.state.invoiceList, 'processType': 0, 'period': this.state.initialValues.financialYearOne, 'frequency': this.state.initialValues.frequencySelected },
    }).then(function (response) {
      if (!response.data.success) {
        //actions.setSubmitting(false);
        //actions.setErrors(response.data);
      } else {
        self.setState({
          messsagePopup: true,
          popupContent: 'Data Saved Successfully'
        });
        setTimeout(function () {
          self.state.formResponseData = [];
          self.setState({})
        })
      }
    });
  }



  selectAll = () => this.selectAllCheckboxes(true);
  selectAllCheckboxes = isSelected => {
    Object.keys(this.state.formResponseData).forEach(checkbox => {
      // BONUS: Can you explain why we pass updater function to setState instead of an object?
      this.setState(prevState => ({
        checkboxes: {
          ...prevState.checkboxes,
          [checkbox]: isSelected
        }
      }));

      this.state.formResponseData[checkbox][this.state.formResponseData[checkbox]['lease_id']] = isSelected;
    });
    this.setState({});
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/transactions/generate" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>Invoicing</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>Transaction</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <a href="#">Approve Invoices</a>
              </li>
            </ul>
          </div>
        </div>


        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          //validationSchema={reportFilterForm}
          onReset={(values, actions) => {
            this.state.brandSelected = [];
            for (const [key, value] of Object.entries(
              this.state.initialValues
            )) {
              this.state.initialValues[key] = "";
            }
            this.state.counter = Math.random();
            this.setState({});
          }}
          onSubmit={(values, actions) => {
            var self = this;
            //this.state.initialValues.financialYearOne = this.state.financialYearOne;
            var prm = Object.entries(this.state.initialValues)
              .map(([key, val]) => `${key}=${val}`)
              .join("&");

            prm += "&requestType=approve";

            var tableCounter, counter = 0;
            console.log(this.state.initialValues, "this.state.initialValues");

            var headers = {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("TOKEN"),
            };
            fetch(
              `${apiUrl.apiUrl.url}/sales-input/fetch-invoice-data?` + prm,
              { headers }
            )
              .then((response) => {
                return response.json();
              })
              .then((data) => {
                //this.setState({  });
                console.log(data, "data");

                // var tableHeading = "";
                // if("Marketing Fund Tax" == this.state.initialValues.chargeTypeSelected) {
                //   tableHeading = "MF";
                // }else  if("Property Tax" == this.state.initialValues.chargeTypeSelected) {
                //   tableHeading = "P TAX";
                // }else if("Parking 2W" == this.state.initialValues.chargeTypeSelected || "Parking 4W" == this.state.initialValues.chargeTypeSelected || "Parking Other" == this.state.initialValues.chargeTypeSelected ) {
                //   tableHeading = "Utility";
                // }else if("Storage" == this.state.initialValues.chargeTypeSelected) {
                //   tableHeading = "Charge";
                // }




                tableCounter = 0;
                this.setState({
                  formResponseData: data.data,
                  invoiceOtherData: data.otherDetails,
                });



                // this.setState({
                //   currentDocument: data.otherDetails.document_url,
                // });

                // this.setState({
                //   totalInvoiceAmount: data.otherDetails.total_amt.invoiceAmount,
                // });
                // this.setState({ fileName: data.otherDetails.fileName });
                // this.setState({ counter: counter });
                // this.setState({
                //   exportUrl:
                //     `${apiUrl.apiUrl.url}/sales-input/fetch-revenue-details?export=true&` +
                //     prm,
                // });
              })
              .catch((error) => {
                console.log(error);
              });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <div className="unitFormContainerNew">
              <Form autoComplete="off">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Landlord Group
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="landlordId"
                              isSearchable="true"
                              onChange={(e) => {
                                this.handleChangeLandlord(e);
                              }}
                              value={{
                                label: this.state.initialValues.groupName,
                                value: this.state.initialValues.groupId,
                              }}
                              options={this.state.landloardList.map((item) => ({
                                label: item.text,
                                value: item.id,
                              }))}
                            />

                            <ErrorMessage
                              name="groupId"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Landlord Asset Name
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="assetName"
                              onChange={(e) => {
                                this.valueChangeAsset(e);
                              }}
                              // value={this.state.brandSelected}
                              value={{
                                label: this.state.initialValues.assetName,
                                value: this.state.initialValues.assetId,
                              }}
                              options={this.state.assetArr.map((item) => ({
                                label: item.asset_name,
                                value: item.id,
                              }))}
                            />
                            {/* <option value="single">Single</option>
                           <option value="multiple">Multiple</option> */}

                            <ErrorMessage
                              name="assetId"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Sub Asset Name
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="subAssetName"
                              // onInputChange={this.handleChange}
                              // onChange={}
                              onChange={(e) => {
                                //handleChange(e);
                                this.valueChangeSubAsset(e);
                              }}
                              value={{
                                label: this.state.initialValues.subAssetName,
                                value: this.state.initialValues.subAssetId,
                              }}
                              options={this.state.subAssetArr.map((item) => ({
                                label: item.sub_asset_name,
                                value: item.id,
                              }))}
                            />

                            <ErrorMessage
                              name="subAssetName"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Tower Name
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="towerId"
                              onInputChange={this.handleChange}
                              //isMulti
                              onChange={(e) => {
                                this.state.initialValues.towerId = e.value;
                              }}
                              //value={this.state.brandSelected}
                              options={this.state.towerArr.map((item) => ({
                                label: item.tower_name,
                                value: item.id,
                              }))}
                            />

                            <ErrorMessage
                              name="towerId"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>



                  <div className="row">


                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Charge Type<span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              //isMulti
                              onChange={(e) => {
                                this.valueChangeChargeType(e);
                              }}
                              value={this.state.chargeTypeSelected}
                              // value={{
                              //   label: this.state.initialValues.chargeType,
                              //   value: this.state.initialValues.chargeType,
                              // }}
                              name="chargeType"
                              options={[
                                "CAM",
                                "RENT",
                                "Property Tax",
                                "Marketing Fund Tax",
                                "Parking 2W",
                                "Parking 4W",
                                "Parking Other",
                                "Storage",
                                "Signage",
                                //"Utility"
                              ].map((item) => ({
                                label: item,
                                value: item,
                              }))}
                            />

                            <ErrorMessage
                              name="chargeType"
                              component="div"
                              className="text-red"
                            />
                            {/* <option value="" label="Select" defaultValue />
                              <option value="Per Month" label="Per Month" />
                            </Field> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Month
                            <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <DatePicker
                              onChange={(date) =>
                                this.setState({ financialYearOne: date })
                              }
                              onBlur={this.handleCalenderOnBlur}
                              dateFormat="MMMM yyyy"
                              showMonthYearPicker
                              selected={this.state.financialYearOne}
                              onCalendarClose={this.handleCalenderOnBlur}
                            />

                            {/* <DatePicker 
                            onChange={(date) => this.setState({ financialYearTwo: date })} 
                            dateFormat="MMMM yyyy"
                            showMonthYearPicker
                            selected={this.state.financialYearTwo}
                            onCalendarClose={this.handleCalenderOnBlur}
                          />   */}
                          </div>
                          <div className="col-sm-3">
                            <ErrorMessage
                              name="financialYearOne"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>

                  <div className="row">
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Invoice Frequency
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="invoiceFrequency"
                              //onInputChange={this.getAssetsList}
                              onInputChange={this.handleChange}
                              // onChange={}
                              onChange={(e) => {
                                //handleChange(e);
                                this.state.initialValues.frequencySelected = e.value;
                                this.setState({})
                                //this.valueFrequencyChange(e, "change_asset_name");
                              }}
                              value={this.state.frequencySelected}
                              //value={this.state.chargeTypeSelected}
                              options={[
                                "Monthly",
                              ].map((item) => ({
                                label: item,
                                value: item,
                              }))}
                            />

                            <ErrorMessage
                              name="assetId"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6 offset-lg-6">
                      <div className="btnContainer">
                        <div>
                          <button type="submit" d1isabled={isSubmitting}>
                            Search
                          </button>
                          <button type="button" onClick={this.selectAll}>
                            Select All
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
        </Formik>

        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>

        <Formik
          initialValues={this.state.formResponseData}
          enableReinitialize
          onChange={({ nextValues }) => {
            console.log(nextValues, "asdasdasd");
          }}
          onReset={(values, actions) => {
            this.setState({
              //formResponseData: data,
              formResponseData: this.state.formResponseData,
            });
          }}
          onSubmit={(values, actions) => {
            var self = this;

            values["leaseId"] = this.state.invoiceOtherData.leaseId;
            values["month"] = this.state.invoiceOtherData.date;

            if (
              this.state.totalInvoiceAmount !=
              this.state.invoiceOtherData.total_amt.net_charge_amount
            ) {
              // alert("please settle invoice amount");
              this.setState({
                popupalertMessage: true,
                popupMessageContent: 'please settle invoice amount',
              });
              return false;
            } else {
              this.uploader.uploadFile();
              values.filename =
                fileUploadPath() +
                this.state.invoiceOtherData.leaseId +
                "/" +
                this.state.fileName;
              values.chargeTypeSelected =
                this.state.initialValues.chargeTypeSelected;
              this.setState({ submitFormData: values });

              this.state.brandSelected = [];
              this.state.leaseSelected = [];
              this.state.securityDepositIds = [];

              for (const [key, value] of Object.entries(
                this.state.initialValues
              )) {
                this.state.initialValues[key] = "";
              }
              this.setState({});
            }
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            handleReset,

            isSubmitting,
          }) => (
            <Form autoComplete="off">
              <div className="container-fluid cam pt-5">
                <div className="row">
                  <div className="col"></div>
                  <div className="tableContainer" style={{ 'overflow-x': 'auto' }}>
                    {this.state.tableTOShow == "RENT" &&
                      <table className="table tableSimple">
                        <thead>
                          <tr>
                            <th scope="col">Sr. No.</th>
                            <th scope="col">Lease Id</th>
                            <th scope="col">Asset Name</th>
                            <th scope="col">Sub Asset Name</th>
                            <th scope="col">Tower</th>
                            <th scope="col">Floor</th>
                            <th scope="col">Unit No.</th>
                            <th scope="col">GLA</th>
                            <th scope="col">Brand Name</th>
                            <th scope="col">Occupier Name</th>
                            <th scope="col">Invoice Period</th>

                            <th scope="col">Charge Logic</th>
                            <th scope="col">Charge Rate</th>
                            <th scope="col">Invoice Number</th>
                            <th scope="col">Charge Base Amount</th>
                            <th scope="col">GST Rate</th>
                            <th scope="col">GST Amount</th>
                            <th scope="col">Gross Amount</th>
                            <th scope="col">TDS Rate</th>
                            <th scope="col">TDS Amount</th>
                            <th scope="col">NET Amount</th>
                            <th scope="col">Select</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.formResponseData.length > 0 &&
                            this.state.formResponseData.map(
                              (anObjectMapped, index) => {
                                return (
                                  <tr>
                                    <td>{index + 1}</td>
                                    <td>{anObjectMapped.leaseName}</td>
                                    <td>{anObjectMapped.assetName}</td>
                                    <td>{anObjectMapped.subAssetName}</td>
                                    <td>{anObjectMapped.tower}</td>
                                    <td>{anObjectMapped.floor}</td>
                                    <td>{anObjectMapped.unit}</td>
                                    <td>{anObjectMapped.grossLeasebleArea}</td>
                                    <td>{anObjectMapped.brandName}</td>
                                    <td>{anObjectMapped.occupierName}</td>
                                    <td>{anObjectMapped.month}</td>

                                    <td>{anObjectMapped.type}</td>
                                    <td>{anObjectMapped.mg_rate}</td>
                                    <td>{`TEMP/${anObjectMapped.lease_id}`}</td>
                                    <td>{anObjectMapped.net_charge_amount}</td>
                                    <td>{anObjectMapped.gst_rate}</td>
                                    <td>{anObjectMapped.gst_amt}</td>
                                    <td>{anObjectMapped.net_charge_amount + anObjectMapped.gst_amt}</td>
                                    <td>{anObjectMapped.tds_rate}</td>
                                    <td>{anObjectMapped.tds_amt}</td>
                                    <td><td>{anObjectMapped.net_charge_amount + anObjectMapped.gst_amt - anObjectMapped.tds_amt}</td></td>
                                    <td>
                                      {/* <Field type="checkbox" name={anObjectMapped.lease_id+"_"+anObjectMapped.type_str}  /> */}
                                      <Checkbox
                                        key={index}
                                        type="checkbox"
                                        name={anObjectMapped.invoice_id}
                                        id={anObjectMapped.invoice_id}
                                        handleClick={this.handleClick}
                                        attr={anObjectMapped.type_str}
                                      //isChecked={isCheck.includes(id)}
                                      />
                                      {/* <input key={anObjectMapped.lease_id} type="checkbox" name="invoiceCheckbox"  value={anObjectMapped.lease_id} onChange={this.handleChangeChk(anObjectMapped.lease_id)}  /> */}
                                    </td>
                                  </tr>
                                );
                              }
                            )}

                        </tbody>
                      </table>
                    }
                    {this.state.formResponseData.length > 0 &&
                      <div className="btnContainer">
                        <button type="button" onClick={this.approveInvoice}>
                          Approve
                        </button>
                        <button type="button" onClick={this.rejectInvoice}>
                          Reject
                        </button>
                      </div>
                    }





                  </div>
                </div>
              </div>

            </Form>
          )}
        </Formik>


      </div>
    );
  }
}

export default withRouter(LeaseExpiryReport);
